import {call, put} from 'redux-saga/effects';
import { getNacAutomationLogsSuccess, getNacAutomationLogsError,
getNacAutomationDetailsByRitmSuccess, getNacAutomationDetailsByRitmError,
getNacAutomatonEventsByRitmSuccess, getNacAutomatonEventsByRitmError } from '../components/network-automation/nac-automation/redux/actions';

import { getNacAutomationLogs, getNacAutomationDetailsByRitm, getNacAutomationEventsByRitm } from '../components/network-automation/nac-automation/NacAutomationService';

function* loadNacAutomationLogs ({requestParams}) {
    try {
        const response = yield call(getNacAutomationLogs, requestParams);
        yield put(getNacAutomationLogsSuccess(response));
    } catch (error) {
        yield put(getNacAutomationLogsError(error.toString()));
    }
}

function* loadNacAutomationDetailsByRitm ({requestId}) {
    try {
        const response = yield call(getNacAutomationDetailsByRitm, requestId);
        yield put(getNacAutomationDetailsByRitmSuccess(response));
    } catch (error) {
        yield put(getNacAutomationDetailsByRitmError(error.toString()));
    }
}

function* loadNacAutomationEventsByRitm ({requestId, switchName, portNumber}) {
    try {
        const response = yield call(getNacAutomationEventsByRitm, requestId, switchName, portNumber);
        yield put(getNacAutomatonEventsByRitmSuccess(response));
    } catch (error) {
        yield put(getNacAutomatonEventsByRitmError(error.toString()));
    }
}

export {loadNacAutomationLogs, loadNacAutomationDetailsByRitm, loadNacAutomationEventsByRitm};